import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import HeroBanner from '../components/HeroBanner';
import { FiBook, FiAward, FiUsers, FiTrendingUp, FiCheckCircle, FiClock, FiShoppingCart, FiArrowRight } from 'react-icons/fi';
import { API_BASE_URL, BASE_URL, institute_id } from '../config/config';
const LandingPage = () => {
  const { user, loading: authLoading } = useAuth();
  const [popularCourses, setPopularCourses] = useState([]);
  const [courseTypes, setCourseTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState(null);

  const isLoggedIn = !!user;


  // Helper function to strip HTML tags and decode HTML entities
  const stripHtml = (html) => {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  };

  const stats = settings?.stats || {
    total_students: 1234,
    total_courses: 50,
    success_rate: 95,
  };

  useEffect(() => {
    // Wait for auth to finish loading before fetching data
    if (authLoading) return;
    
    fetchSiteSettings();
    fetchPopularCourses();
    fetchCourseTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authLoading, user]);

  const fetchSiteSettings = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/site-settings?institute_id=${institute_id}`);
      const data = await response.json();
      if (data.success) {
        setSettings(data.data);
      }
    } catch (error) {
      console.error('Error fetching site settings:', error);
    }
  };

  const fetchCourseTypes = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/coursecategory?institute_id=${institute_id}`);
      const data = await response.json();
      if (data.success) {
        console.log('Course Types Data:', data.data);
        setCourseTypes(data.data);
      }
    } catch (error) {
      console.error('Error fetching course types:', error);
    }
  };

  const fetchPopularCourses = async () => {
    try {
      const email = isLoggedIn ? user.email : 'guest@example.com';
      const response = await fetch(`${API_BASE_URL}/popularcourse?email=${email}&type=popular&institute_id=${institute_id}`);
      const data = await response.json();

      if (data.success) {
        setPopularCourses(data.data.slice(0, 6)); // Show only 6 courses
      }
    } catch (error) {
      console.error('Error fetching courses:', error);
    } finally {
      setLoading(false);
    }
  };

  const features = [
    {
      icon: FiBook,
      title: 'Quality Content',
      description: 'Comprehensive study materials prepared by expert educators',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      icon: FiAward,
      title: 'Expert Teachers',
      description: 'Learn from experienced faculty with proven track records',
      color: 'bg-green-100 text-green-600'
    },
    {
      icon: FiUsers,
      title: 'Test Series',
      description: 'Practice with AI-powered quizzes and mock tests',
      color: 'bg-purple-100 text-purple-600'
    },
    {
      icon: FiTrendingUp,
      title: 'Track Progress',
      description: 'Monitor your performance with detailed analytics',
      color: 'bg-orange-100 text-orange-600'
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <PublicHeader />
      
      {/* Hero Banner */}
      <HeroBanner />

 

      {/* Course Types Section - Mobile App Style */}
  {courseTypes.length > 0 && (
       <section className="py-6 sm:py-8 lg:py-12 bg-gray-50">
         <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
           <div className="text-center mb-6 sm:mb-8">
             <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
               Select Your Goal
             </h2>
             <p className="text-sm sm:text-base text-gray-600">
               Choose your path to success
             </p>
           </div>

           {/* Clean Testbook-style Category Cards */}
           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 mb-6">
             {courseTypes.map((type) => (
               <Link
                 key={type.id}
                 to={`/courses?category=${type.id}`}
                 className="w-full flex items-center justify-between p-4 bg-white rounded-xl transition-all border border-gray-200 hover:border-gray-300 shadow-sm hover:shadow-md"
               >
                 <div className="flex items-center gap-3">
                   <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center flex-shrink-0 overflow-hidden">
                     {type.feature_image ? (
                       <img
                         src={type.feature_image.startsWith('http') ? type.feature_image : `${API_BASE_URL}/${type.feature_image}`}
                         alt={type.type}
                         className="w-8 h-8 object-contain"
                         onError={(e) => {
                           e.target.style.display = 'none';
                           e.target.parentElement.innerHTML = '<div class="w-8 h-8 rounded bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-sm">' + type.type.charAt(0) + '</div>';
                         }}
                       />
                     ) : (
                       <div className="w-8 h-8 rounded bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-sm">
                         {type.type.charAt(0)}
                       </div>
                     )}
                   </div>
                   <span className="text-base font-semibold text-gray-900 text-left">
                     {type.type}
                   </span>
                 </div>
                 <FiArrowRight className="w-5 h-5 text-gray-400 flex-shrink-0" />
               </Link>
             ))}
           </div>

           {/* View All Button - Clean Style */}
           <div className="text-center">
             <Link
               to="/courses"
               className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold text-sm transition-all shadow-sm hover:shadow-md"
             >
               View All 
               <FiArrowRight className="ml-2 w-4 h-4" />
             </Link>
           </div>
         </div>
       </section>
     )}

           {/* Popular Courses Section - Mobile App Style */}
           <section className="py-6 sm:py-8 lg:py-12 bg-transparent">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
          <div className="flex items-center justify-between mb-4 sm:mb-6">
            <div>
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-1">
                🔥 Popular Courses
              </h2>
              <p className="text-sm sm:text-base lg:text-lg text-gray-600 hidden sm:block">
                Most loved courses by our students
              </p>
            </div>
            <Link
              to="/courses"
              className="hidden lg:inline-flex items-center px-5 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all active:scale-95"
            >
              View All →
            </Link>
          </div>

          {loading ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3 lg:gap-4">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="bg-white rounded-xl sm:rounded-2xl shadow-md animate-pulse p-3">
                  <div className="bg-gray-200 h-32 sm:h-40 lg:h-44 rounded-lg mb-3"></div>
                  <div className="bg-gray-200 h-4 rounded mb-2"></div>
                  <div className="bg-gray-200 h-3 rounded w-2/3"></div>
                </div>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3 lg:gap-4">
              {popularCourses.map((course) => {
                const finalPrice = (course.price - (course.price * course.discount / 100)).toFixed(2);
                const isPurchased = course.purchased > 0;

                return (
                  <div
                    key={course.id}
                    className="bg-white rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-all active:scale-95 overflow-hidden"
                  >
                    {/* Course Image */}
                    <Link to={`/course-details/${course.id}`} className="block">
                      <div className="relative rounded-t-xl sm:rounded-t-2xl overflow-hidden">
                        <img
                          src={`${course.course_thumbnail}`}
                          alt={course.title}
                          className="w-full h-32 sm:h-40 lg:h-44 object-cover group-hover:scale-110 transition-transform duration-300"
                          onError={(e) => {
                            e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%236366f1" width="400" height="300"/%3E%3C/svg%3E';
                          }}
                        />
                        {course.discount > 0 && (
                          <div className="absolute top-2 left-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-2 py-1 rounded-full text-[10px] sm:text-xs font-bold shadow-lg">
                            {course.discount}% OFF
                          </div>
                        )}
                        {isPurchased && (
                          <div className="absolute top-2 right-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-bold flex items-center gap-1 shadow-lg">
                            <FiCheckCircle className="w-3 h-3" />
                            OWNED
                          </div>
                        )}
                      </div>
                    </Link>

                    {/* Course Info */}
                    <div className="p-3 sm:p-4">
                      <Link to={`/course-details/${course.id}`}>
                        <h3 className="text-sm sm:text-base lg:text-lg font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors line-clamp-2 leading-tight">
                          {course.title}
                        </h3>
                      </Link>

                      <div className="flex items-center justify-between text-[10px] sm:text-xs text-gray-600 mb-3">
                        <span className="flex items-center gap-1">
                          <FiBook className="w-3 h-3 sm:w-4 sm:h-4" />
                          {course.tradeName || 'General'}
                        </span>
                        {course.validity && (
                          <span className="flex items-center gap-1">
                            <FiClock className="w-3 h-3 sm:w-4 sm:h-4" />
                            {course.validity} M
                          </span>
                        )}
                      </div>

                      {/* Price */}
                      <div className="flex items-center justify-between mb-3">
                        
                        <div>
                          
                          <span className="text-lg sm:text-xl lg:text-2xl font-bold text-blue-600">
                            ₹{finalPrice}
                          </span>
                          {course.discount > 0 && (
                            <span className="text-[10px] sm:text-xs text-gray-500 line-through ml-2 sm:ml-2">
                              ₹{course.price.toFixed(2)}
                            </span>
                          )}
                        </div>
                        {/* {course.discount > 0 && (
                          <span className="text-[9px] sm:text-[10px] bg-gradient-to-r from-green-100 to-emerald-100 text-green-700 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full font-bold border border-green-300">
                            Save ₹{(course.price - finalPrice).toFixed(0)}
                          </span>
                        )} */}
                      </div>
                      

                      {/* Action Buttons */}
                      {isPurchased ? (
                        <Link
                          to={`/course/${course.id}`}
                          state={{ course }}
                          className="w-full flex items-center justify-center gap-1 sm:gap-2 px-3 py-2 sm:py-2.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-b-xl sm:rounded-b-2xl font-bold text-xs sm:text-sm transition-all hover:shadow-lg active:scale-95"
                        >
                          <FiBook className="w-3 h-3 sm:w-4 sm:h-4" />
                          Open Course
                        </Link>
                      ) : (
                        <div className="flex flex-col gap-1.5 sm:gap-2">
                          {/* Enroll Now Button */}
                          <Link
                            to={`/course-details/${course.id}`}
                            className="w-full flex items-center justify-center gap-1 px-3 py-2 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg font-bold text-xs sm:text-sm transition-all hover:shadow-lg active:scale-95"
                          >
                            <FiShoppingCart className="w-3 h-3 sm:w-4 sm:h-4" />
                            Enroll Now
                          </Link>

                          {/* View Course Button */}
                          <Link
                            to={`/course/${course.id}`}
                            state={{ course }}
                            className="w-full flex items-center justify-center gap-1 px-3 py-1.5 bg-blue-50 text-blue-600 rounded-lg font-semibold text-[10px] sm:text-xs transition-all hover:bg-blue-100 active:scale-95"
                          >
                            <FiBook className="w-3 h-3" />
                            View Course
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div className="text-center mt-4 sm:mt-6 lg:hidden">
            <Link
              to="/courses"
              className="inline-flex items-center justify-center px-6 py-2.5 sm:py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl font-bold text-sm sm:text-base shadow-lg hover:shadow-xl transition-all active:scale-95 w-full sm:w-auto"
            >
              View All Courses →
            </Link>
          </div>
        </div>
      </section>
      {/* Welcome Section */}
      <section className="py-16 bg-white hidden lg:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 capitalize">
              Welcome to {JSON.parse(localStorage.getItem('settings'))?.site_name}
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Your Gateway to Success in Competitive Exams
            </p>
            <p className="text-gray-600 leading-relaxed">
              We provide quality education and comprehensive study materials for students aspiring to crack competitive exams. Join thousands of successful students who achieved their dreams with us.
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-2">
                {stats.total_students}+
              </div>
              <div className="text-gray-600">Happy Students</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-2">
                {stats.total_courses}+
              </div>
              <div className="text-gray-600">Quality Courses</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-2">
                {stats.success_rate}%
              </div>
              <div className="text-gray-600">Success Rate</div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-50 hidden lg:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose Us?
            </h2>
            <p className="text-xl text-gray-600">
              Everything you need to succeed in one place
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features && features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className="card hover:shadow-xl transition-all">
                  <div className={`w-16 h-16 ${feature.color} rounded-lg flex items-center justify-center mb-4`}>
                    <Icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>



      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-primary-500 to-purple-600 text-white hidden lg:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Start Your Learning Journey?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Join thousands of successful students today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/courses"
              className="px-8 py-3 bg-white text-primary-600 rounded-lg font-semibold hover:shadow-xl transition-all transform hover:scale-105"
            >
              Browse Courses
            </Link>
            {!isLoggedIn && (
              <Link
                to="/register"
                className="px-8 py-3 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-primary-600 transition-all"
              >
                Register Now
              </Link>
            )}
          </div>
        </div>
      </section>
      <section className="hidden lg:block">
        <Footer />
      </section>

    </div>
  );
};

export default LandingPage;

